import React from 'react';
//import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
//import { blue } from '@material-ui/core/colors';

import { Grid, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

/*
const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});
*/


export default function SimpleDialog(props) {
    const { onOk, openPackageNotFound} = props;
    const { t } = useTranslation();

    const handleOkGoToHomepage = () => {
        onOk();
    };

    // onClose={handleClose} 
    return (
        <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={openPackageNotFound} keepMounted>
            <div className='ugly modalBody p-4'>

                <Grid container id="PackageNotFoundModal" className="UserNotificationModal">
                    <Grid item className='text-center' xs={12}>
                        <div className="heading">
                            <img alt={t('package.modals.packageNotFound.heading')} src="/images/modals/package-not-found-heading.png" className="package-not-found-image" /><h3>{t('package.modals.packageNotFound.heading')}</h3>
                        </div>
                    </Grid>
                    <Grid item className='mb-4 text-center heading' xs={12} >
                        <div className="content">
                            <h3>{t('package.modals.packageNotFound.message')}</h3>
                        </div>
                    </Grid>
                    <Grid item  className='text-center' xs={12}><Button onClick={handleOkGoToHomepage} variant='contained' color='secondary' title={t('common.buttons.showMoreDeals')}>{t('package.modals.packageNotFound.button')}</Button></Grid>
                </Grid>
            </div>

        </Dialog>
    );
}
